import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer, createTransform, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/es/storage';

import { allReducers } from './reducers';

// The theme slice holds transient live-preview fields that mirror unsaved edits. The uploaded
// logo preview is a File, which cannot be JSON-serialised — it persists as {} and rehydrates as a
// stale non-File value that breaks the preview reset. Strip every preview field before persisting
// so they always rehydrate from the reducer's initial defaults.
const themeTransform = createTransform(
    (inboundState) => {
        const persistedTheme = { ...inboundState };
        delete persistedTheme.logoUploadedPreview;
        delete persistedTheme.sidebarColourPreview;
        delete persistedTheme.sidebarTextColourPreview;
        delete persistedTheme.sidebarActiveMenuColourPreview;
        return persistedTheme;
    },
    (outboundState) => outboundState,
    { whitelist: ['theme'] }
);

var persistConfig = {
    key: 'root',
    storage,
    // rulesEngine holds the driver an internal operator is inspecting and the diff viewer's hand-over to the
    // harness. Persisting it would leave driver identifiers in localStorage after logout on a shared machine.
    blacklist: ['dirtyData', 'rulesEngine'],
    transforms: [themeTransform],
};

var persistedReducer = persistReducer(persistConfig, allReducers);

export var store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: {
            ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
    }),
});

export var persistor = persistStore(store);
